export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'PhoneIcon',
  },
  // {
  //   title: 'Post Replies',
  //   faIcon: 'fas fa-reply',
  //   route: 'digital-replies',
  // },
]
